import { Badge } from 'react-bootstrap';

function DangerBadge({ children }) {
  return (
    <Badge pill bg="danger" className={`ms-2`}>
      {children}
    </Badge>
  );
}

export default DangerBadge;
